<script>
	import { onMount } from "svelte";
	import { menu, menuSub, menuSubSub } from "../../stores";
	import SendMailModal from "./SendMailModal.svelte";

	let showMailModal = false;

	const showHideModal = () => {
		showMailModal = !showMailModal;
	}

	onMount(() => {
		menu.set("이메일 관리");
		menuSub.set("발송 테스트");
		menuSubSub.set("");
	});
</script>

<div class="card mb-4">
	<div class="card-header">
		<button class="btn btn-success btn-sm" on:click={showHideModal}>
			발송
			<i class="bx bx-send"></i>
		</button>
		<SendMailModal 
			handleShowHideModal = {showHideModal}
			showModal = {showMailModal}/>
	</div>
</div>
